import { Link } from "react-router-dom";
import { Facebook, Instagram, MessageCircle, Mail, Phone } from "lucide-react";
import { TikTokIcon } from "@/components/TikTokIcon";
import { WHATSAPP_NUMBER, WHATSAPP_DISPLAY, TIKTOK_URL, TIKTOK_HANDLE } from "@/lib/contact";

export const Footer = () => {
  return (
    <footer className="bg-[#1C1C1C] text-[#F4F1EA] mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-20 lg:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 lg:gap-12">
          <div className="md:col-span-5">
            <div className="font-heading font-bold text-4xl sm:text-5xl tracking-tight text-balance">
              Sangkar Murah<br />
              <span className="text-[#E07A5F]">Enterprise.</span>
            </div>
            <p className="mt-5 text-sm text-[#F4F1EA]/70 max-w-md leading-relaxed">
              Pembekal sangkar kucing custom-made berkualiti tinggi di Malaysia.
              Setiap sangkar dibuat khas mengikut saiz dan keperluan pelanggan.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-[#F4F1EA]/20 flex items-center justify-center hover:bg-[#25D366] hover:border-[#25D366] transition" data-testid="social-whatsapp" aria-label="WhatsApp">
                <MessageCircle className="w-4 h-4" />
              </a>
              <a href={TIKTOK_URL} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-[#F4F1EA]/20 flex items-center justify-center hover:bg-[#E07A5F] hover:border-[#E07A5F] transition" data-testid="social-tiktok" aria-label="TikTok">
                <TikTokIcon className="w-4 h-4" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-[#F4F1EA]/20 flex items-center justify-center hover:bg-[#E07A5F] hover:border-[#E07A5F] transition" data-testid="social-instagram" aria-label="Instagram">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-[#F4F1EA]/20 flex items-center justify-center hover:bg-[#E07A5F] hover:border-[#E07A5F] transition" data-testid="social-facebook" aria-label="Facebook">
                <Facebook className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="label-eyebrow text-[#E07A5F]">Navigasi</div>
            <ul className="mt-5 space-y-3">
              <li><Link to="/" className="text-sm text-[#F4F1EA]/80 hover:text-[#E07A5F]">Laman Utama</Link></li>
              <li><Link to="/katalog" className="text-sm text-[#F4F1EA]/80 hover:text-[#E07A5F]">Katalog Sangkar</Link></li>
              <li><Link to="/tentang" className="text-sm text-[#F4F1EA]/80 hover:text-[#E07A5F]">Tentang Kami</Link></li>
              <li><Link to="/hubungi" className="text-sm text-[#F4F1EA]/80 hover:text-[#E07A5F]">Hubungi & FAQ</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="label-eyebrow text-[#E07A5F]">Hubungi Kami</div>
            <ul className="mt-5 space-y-4 text-sm text-[#F4F1EA]/80">
              <li className="flex items-center gap-3">
                <MessageCircle className="w-4 h-4 text-[#25D366] shrink-0" />
                <a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noreferrer" className="hover:text-[#E07A5F]">
                  WhatsApp: {WHATSAPP_DISPLAY}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-[#81B29A] shrink-0" />
                <span>{WHATSAPP_DISPLAY}</span>
              </li>
              <li className="flex items-center gap-3">
                <TikTokIcon className="w-4 h-4 text-[#E07A5F] shrink-0" />
                <a href={TIKTOK_URL} target="_blank" rel="noreferrer" className="hover:text-[#E07A5F]">
                  TikTok: @{TIKTOK_HANDLE}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#81B29A] shrink-0" />
                <span>hello@sangkarmurah.my</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#F4F1EA]/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-[#F4F1EA]/50">
            © {new Date().getFullYear()} Sangkar Murah Enterprise. Hak cipta terpelihara.
          </p>
          <p className="text-xs text-[#F4F1EA]/50">
            Penghantaran seluruh Malaysia · Penghantaran lori kedai
          </p>
        </div>
      </div>
    </footer>
  );
};
